import React, { useEffect, useState } from "react";
import { ReactSelectField } from "../../components/ReactHooksFormFields/ReactSelectField";
import { InputField } from "../../components/ReactHooksFormFields/inputField";
import { DatePickerField } from "../../components/ReactHooksFormFields/DatePickerField";
import { CheckBox } from "../../components/ReactHooksFormFields/checkBox";
import {
  demographicsApi,
  useAmendmentRequestMutation,
  useGetDemographicListingQuery,
  useGetDemographicsQuery,
} from "../../redux/service/demographic_services";
import { useForm, useWatch } from "react-hook-form";
import { MaskField } from "../../components/ReactHooksFormFields/MaskField";
import { AsyncSelectField } from "../../components/ReactHooksFormFields/AsyncSelectField";
import moment from "moment";
import { toast } from "react-toastify";
import FullScreenLoader from "../../components/FullScreenLoader";
function reArrangeData(data) {
  return { new_value: data, current_value: data };
}
function EditForm({ crossHandler, locationDetail }) {
  const {
    control,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const { data, isLoading } = useGetDemographicListingQuery();
  const { data: demographicData } = useGetDemographicsQuery();
  const [getLanguage] = demographicsApi.endpoints.getLanguage.useLazyQuery();
  const [amendmentRequest] = useAmendmentRequestMutation();
  const gender = useWatch({
    control: control,
    name: "sex.new_value",
  });
  const genderIdentity = useWatch({
    control: control,
    name: "gender_identity.new_value",
  });
  const sexualOrientation = useWatch({
    control: control,
    name: "sexual_orientation.new_value",
  });
  useEffect(() => {
    // setLoading(true);
    if (demographicData) {
      const {
        patient: Patient,
        CareProvider,
        contacts,
      } = demographicData?.data?.demographics;
      let obj = {
        fname: reArrangeData(Patient?.fname),
        lname: reArrangeData(Patient?.lname),
        mname: reArrangeData(Patient?.mname),
        suffix: reArrangeData(Patient?.suffix),
        ss: reArrangeData(Patient?.full_ssn),
        title: reArrangeData(Patient?.title),
        sex: reArrangeData(Patient?.sex),
        DOB: reArrangeData(
          Patient?.DOB &&
            moment(Patient?.DOB, "YYYY-MM-DD").format("MM/DD/YYYY")
        ),
        gender_identity: reArrangeData(
          Patient?.gender_identity && Patient?.gender_identity
        ),
        fax: reArrangeData(Patient?.fax),
        phone_biz_ext: reArrangeData(Patient?.phone_biz_ext),
        phone_biz: reArrangeData(Patient?.phone_biz),
        phone_cell: reArrangeData(Patient?.phone_cell),
        phone_home: reArrangeData(Patient?.phone_home),
        email: reArrangeData(Patient?.email),
        country_code:
          Patient?.country_code && reArrangeData(Patient?.country_code),
        state: Patient?.state && reArrangeData(Patient?.state),
        mother_lname: reArrangeData(Patient?.mother_lname),
        mothersname: reArrangeData(Patient?.mothersname),
        street: reArrangeData(Patient?.street),
        street2: reArrangeData(Patient?.street2),
        city: reArrangeData(Patient?.city),
        postal_code: reArrangeData(Patient?.postal_code),
        ethnicties: reArrangeData(Patient?.ethnicties),
        races: reArrangeData(Patient?.races),
        gender_identity_displayfield: reArrangeData(
          Patient?.gender_identity_displayfield
        ),
        sexual_orientation_displayfield: reArrangeData(
          Patient?.sexual_orientation_displayfield
        ),
        language: reArrangeData(
          Patient?.language && {
            id: Patient?.language,
            title: Patient?.language_title,
          }
        ),
        marital_status:
          Patient?.marital_status &&
          Patient?.marital_status != "0" &&
          reArrangeData(Patient?.marital_status),
        sexual_orientation:
          Patient?.sexual_orientation &&
          Patient?.sexual_orientation_title &&
          reArrangeData(Patient?.sexual_orientation),
        residential_status:
          Patient?.residential_status &&
          Patient?.residential_status_title &&
          reArrangeData({
            id: Patient?.residential_status,
            title: Patient?.residential_status_title,
          }),
        veteran: reArrangeData(Patient?.veteran),
        mrn: Patient?.mrn,
      };
      reset(obj);
    }
  }, [demographicData]);

  const submitHandler = (data) => {
    setLoading(true);
    delete data?.mrn;
    let amendments = {
      ...data,
      DOB: {
        current_value: moment(data?.DOB?.current_value).format("YYYY-MM-DD"),
        new_value: moment(data?.DOB?.new_value).format("YYYY-MM-DD"),
      },
      residential_status: {
        current_value: data?.residential_status?.current_value?.id,
        new_value: data?.residential_status?.new_value?.id,
        new_value_obj: data?.residential_status?.new_value
          ? [data?.residential_status?.new_value]
          : [],
      },
      language: {
        current_value: data?.language?.current_value?.id,
        new_value: data?.language?.new_value?.id,
      },
    };
    let sendindObj = {
      amendments,
      object_id: "0",
      object_type: "demographics",
      pid: demographicData?.data?.demographics?.patient?.pid,
    };
    amendmentRequest(sendindObj).then((res) => {
      setLoading(false);
      if (res?.data?.code == 0) {
        toast.success(res?.data?.msg);
        crossHandler();
      } else {
        toast.error(res?.data?.msg);
      }
    });
  };
  const SearchLanguage = async (query) => {
    if (query.length > 2) {
      const response = await getLanguage({
        keyword: query,
      });
      const res = response?.data?.response?.data?.map((v, k) => {
        return { ...v };
      });
      return new Promise(function (resolve, reject) {
        resolve(res || []);
      });
    }
  };
  const WorkWatch = watch("phone_biz.new_value");
  const HomeWatch = watch("phone_home.new_value");
  const MobileWatch = watch("phone_cell.new_value");
  return (
    <div className="grid grid-cols-4 gap-5">
      {(isLoading || loading) && <FullScreenLoader />}
      <div className="col-span-4">
        <div className="flex justify-between border-b pb-3">
          <p className="text-2xl font-semibold">Edit Demographics</p>
          <div className="flex">
            <button
              onClick={handleSubmit(submitHandler)}
              className="mr-3 bg-blue-600 text-white group flex gap-x-3 rounded-md px-3 py-2 text-sm leading-6 font-semibold">
              Save
            </button>
            <button
              onClick={crossHandler}
              className="bg-gray-300 text-black border group flex gap-x-3 rounded-md px-3 py-2 text-sm leading-6 font-semibold">
              Cancel
            </button>
          </div>
        </div>
      </div>
      <ReactSelectField
        control={control}
        name="title.new_value"
        title="Title"
        optionData={data?.data?.titles}
        showLabel="title"
        uniqueKey="id"
        autoComplete="nope"
      />
      <InputField
        control={control}
        name="fname.new_value"
        title="First Name"
        rules={{ required: { value: true } }}
        errors={errors}
        autoComplete="nope"
      />
      <InputField
        control={control}
        name="mname.new_value"
        title="Middle Name"
        autoComplete="nope"
      />
      <InputField
        control={control}
        name="lname.new_value"
        title="Last Name"
        autoComplete="nope"
      />
      <InputField
        control={control}
        name="suffix.new_value"
        title="Suffix"
        autoComplete="nope"
      />
      <MaskField
        mask="999-99-9999"
        control={control}
        name="ss.new_value"
        title="SSN"
        rules={{
          required: {
            value: false,
          },
          pattern: {
            value: /^\d{3}-\d{2}-\d{4}$/,
            message: "Please Enter Correct Number",
          },
        }}
        errors={errors}
        autoComplete="nope"
      />
      <ReactSelectField
        control={control}
        name="sex.new_value"
        title="Gender"
        optionData={data?.data?.sex}
        rules={{ required: { value: true } }}
        showLabel="title"
        uniqueKey="id"
        autoComplete="nope"
      />
      <div>
        {gender == "unknown" && (
          <ReactSelectField
            control={control}
            name="sex_assigned_at_birth.new_value"
            title="Sex Assigned at Birth"
            optionData={[{ label: "Male" }, { label: "Female" }]}
            uniqueKey="label"
            autoComplete="nope"
          />
        )}
      </div>
      <ReactSelectField
        control={control}
        optionData={data?.data?.gender_identity}
        showLabel="title"
        name="gender_identity.new_value"
        title="Gender Identification"
        uniqueKey="id"
        autoComplete="nope"
      />
      <InputField
        control={control}
        name="gender_identity_displayfield.new_value"
        isDisabled={
          data?.data?.gender_identity?.find((v, k) => v?.id == genderIdentity)
            ?.title == "Other, please specify"
            ? false
            : true
        }
        title="Other"
        autoComplete="nope"
      />
      <ReactSelectField
        control={control}
        optionData={data?.data?.sexual_orientation}
        showLabel="title"
        name="sexual_orientation.new_value"
        title="Sexual Orientation"
        uniqueKey="id"
        autoComplete="nope"
      />
      <InputField
        control={control}
        name="sexual_orientation_displayfield.new_value"
        isDisabled={
          data?.data?.sexual_orientation?.find(
            (v, k) => v?.id == sexualOrientation
          )?.title == "Something else, please describe"
            ? false
            : true
        }
        title="Other"
        autoComplete="nope"
      />
      <ReactSelectField
        control={control}
        name="marital_status.new_value"
        title="Marital Status"
        optionData={data?.data?.marital}
        showLabel="title"
        uniqueKey="id"
        autoComplete="nope"
      />
      <DatePickerField
        control={control}
        name="DOB.new_value"
        title="DOB"
        dateTime={false}
        autoComplete="nope"
      />
      <AsyncSelectField
        showLabel="title"
        search={(query) => SearchLanguage(query)}
        control={control}
        name="language.new_value"
        title="Preferred Language"
        errors={errors}
      />
      <InputField
        control={control}
        name="mrn"
        title="MRN"
        isDisabled={true}
        autoComplete="nope"
      />
      <div className="col-span-2">
        <ReactSelectField
          control={control}
          optionData={data?.data?.race}
          showLabel="title"
          isMulti={true}
          name="races.new_value"
          title="Select Race"
        />
      </div>
      <div className="col-span-2">
        <ReactSelectField
          control={control}
          name="ethnicties.new_value"
          title="Ethnicity"
          showLabel="title"
          optionData={data?.data?.ethnicity}
          isMulti={true}
        />
      </div>
      <div className="col-span-4 border-b pb-2 -mb-2">Address</div>
      <div className="col-span-2">
        <InputField
          control={control}
          name="street.new_value"
          title="Line 1"
          rules={{ required: { value: true } }}
          placeholder="Address (Line 1)"
          autoComplete="nope"
        />
      </div>
      <div className="col-span-2">
        <InputField
          control={control}
          name="street2.new_value"
          title="Line 2"
          //   rules={{ required: { value: true } }}
          placeholder="Address (Line 2)"
          autoComplete="nope"
        />
      </div>
      <InputField
        control={control}
        name="city.new_value"
        title="City"
        rules={{ required: { value: true } }}
        errors={errors}
        autoComplete="nope"
      />

      <ReactSelectField
        control={control}
        name="state.new_value"
        title="State"
        rules={{ required: { value: true } }}
        optionData={data?.data?.state}
        showLabel="id"
        uniqueKey="id"
      />
      <InputField
        control={control}
        name="postal_code.new_value"
        title="Zip Code"
        rules={{
          required: { value: true },
          pattern: {
            value: /^[0-9]{5}$|^[0-9]{9}$/,
            message: "Zip Number length should be 5 or 9",
          },
        }}
        errors={errors}
        autoComplete="nope"
      />
      <ReactSelectField
        control={control}
        name="country_code.new_value"
        title="Country"
        rules={{ required: { value: true } }}
        optionData={data?.data?.country}
        showLabel="title"
        uniqueKey="option_id"
        autoComplete="nope"
      />
      <MaskField
        mask="(999) 999-9999"
        control={control}
        name="phone_home.new_value"
        title="Home Phone"
        errors={errors}
        rules={{
          required: {
            value: WorkWatch || MobileWatch ? false : true,
            // message: "Please Enter value",
          },
          pattern: {
            value: /^^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
            message: "Please Enter Correct Number",
          },
        }}
        autoComplete="nope"
      />
      <div className="grid grid-cols-3 flex gap-2">
        <div className="col-span-2">
          <MaskField
            mask="(999) 999-9999"
            control={control}
            name="phone_biz.new_value"
            title="Work Phone"
            errors={errors}
            rules={{
              required: {
                value: HomeWatch || MobileWatch ? false : true,
                // message: "Please Enter value",
              },
              pattern: {
                value: /^^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
                message: "Please Enter Correct Number",
              },
            }}
            autoComplete="nope"
          />
        </div>
        <div className="mt-6">
          <MaskField
            mask="9999"
            name="phone_biz_ext.new_value"
            control={control}
            title=""
            autoComplete="nope"
          />
        </div>
      </div>
      <MaskField
        mask="(999) 999-9999"
        control={control}
        name="phone_cell.new_value"
        title="Mobile Phone"
        errors={errors}
        rules={{
          required: {
            value: HomeWatch || WorkWatch ? false : true,
            // message: "Please Enter value",
          },
          pattern: {
            value: /^^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
            message: "Please Enter Correct Number",
          },
        }}
        autoComplete="nope"
      />
      <MaskField
        mask="(999) 999-9999"
        control={control}
        name="fax.new_value"
        title="Fax"
        errors={errors}
        autoComplete="nope"
      />
      <div className="col-span-4 grid grid-cols-3 gap-3 items-end">
        <InputField
          control={control}
          name="email.new_value"
          title="Email"
          autoComplete="nope"
        />
        <InputField
          control={control}
          title="Mother's Maiden Name"
          name="mothersname.new_value"
          autoComplete="nope"
        />

        <InputField
          control={control}
          title=""
          name="mother_lname.new_value"
          autoComplete="nope"
        />
      </div>
      {locationDetail?.is_fqhc && (
        <>
          <div className="">
            <ReactSelectField
              control={control}
              name="residential_status.new_value"
              title="Residential Status"
              optionData={data?.data?.residential_status}
              showLabel="title"
            />
          </div>

          <div className="flex items-end mb-2">
            <CheckBox
              name="veteran.new_value"
              title="Veteran"
              control={control}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default EditForm;
